// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    grantId: z.string().min(1).max(128),
    grantModelName: z.string().min(1).max(64).optional(),
    organizationId: z.string().min(1).max(21),
    userId: z.string().min(1).max(128),
});
const guard = z.object({
    tenantId: z.string().max(21),
    grantId: z.string().min(1).max(128),
    grantModelName: z.string().max(64),
    organizationId: z.string().min(1).max(21),
    userId: z.string().min(1).max(128),
});
export const CimdGrantOrganizations = Object.freeze({
    table: 'cimd_grant_organizations',
    tableSingular: 'cimd_grant_organization',
    fields: {
        tenantId: 'tenant_id',
        grantId: 'grant_id',
        grantModelName: 'grant_model_name',
        organizationId: 'organization_id',
        userId: 'user_id',
    },
    fieldKeys: [
        'tenantId',
        'grantId',
        'grantModelName',
        'organizationId',
        'userId',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
